/**
 * Allows extensions to be dynamically loaded based on a feature toggle or experiment, while also
 * ensuring that they are _always_ loaded if they are detected as being a development package,
 * or under test via the harness environment (window.cadmium).
 */
var isExtensionEnabled = function (isEnabledViaToggleOrExperiment, packageName) {
    if (isEnabledViaToggleOrExperiment)
        return true;
    if (isPackageUnderDevelopment(packageName)) {
        console.warn("The extension package \"".concat(packageName, "\" is disabled via feature toggle/experiment, ") +
            'but will be loaded as it is present as a development package');
        return true;
    }
    if (isPackageUnderTest(packageName)) {
        console.warn("The extension package \"".concat(packageName, "\" is disabled via feature toggle/experiment, ") +
            'but will be loaded as it is being tested');
        return true;
    }
    return false;
};
/**
 * Checks whether the package is listed as a development package.
 */
var isPackageUnderDevelopment = function (packageName) { var _a; return Boolean(window.cadmium && ((_a = window.cadmium.ports) === null || _a === void 0 ? void 0 : _a[packageName])); };
/**
 * Checks whether the package is under test (e.g. during local/remote FABRiC testing).
 */
var isPackageUnderTest = function (packageName) {
    return Boolean(window.cadmium && window.cadmium.packageUnderTestName === packageName);
};
export { isExtensionEnabled };
//# sourceMappingURL=isExtensionEnabled.js.map